import { render, staticRenderFns } from "./DelayDiscountTab.vue?vue&type=template&id=2578fb06&scoped=true&"
import script from "./DelayDiscountTab.vue?vue&type=script&lang=js&"
export * from "./DelayDiscountTab.vue?vue&type=script&lang=js&"
import style0 from "./DelayDiscountTab.vue?vue&type=style&index=0&id=2578fb06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2578fb06",
  null
  
)

export default component.exports